export default {
  // sys admin - organizations list header
  'organizations.title': 'Organizations',
  'organizations.createOrganizationBtn': 'Create organization',

  // organizations table column headers
  'organizations.tableHeader.name': 'Name',
  'organizations.tableHeader.status': 'Status',
  'organizations.tableHeader.type': 'Type',
  'organizations.tableHeader.subType': 'Subtype',
  'organizations.tableHeader.creationDate': 'Creation date',

  'organizations.createEditDialog.successCreateTextCreate':
    'Organization was created successfully.',
  'organizations.createEditDialog.successEditTextCreate': 'Organization was updated successfully.',

  // organizations datasets dialog
  'organizations.datasetsDialog.title': 'Manage data sets',
  'organizations.datasetsDialog.subTitle': 'Data sets',
  'organizations.datasetsDialog.leftTitle': 'Unavailable',
  'organizations.datasetsDialog.rightTitle': 'Available',
  'organizations.datasetsDialog.description':
    'Select which data sets will be available to all users of this organization.',
  'organizations.datasetsDialog.saveButton': 'Save changes',
  'organizations.datasetsDialog.confirmChanges': 'Confirm changes',
  'organizations.createEditDialog.savingChangesBtnLabel': 'Saving changes',

  // organizations datasets dialog confirmation step
  'organizations.datasetsDialog.confirmationStep.title': 'Confirm changes',
  'organizations.datasetsDialog.confirmationStep.availableDataSets': 'Available data sets:',
  'organizations.datasetsDialog.confirmationStep.madeAvailableDataSets':
    'Data sets made available:',
  'organizations.datasetsDialog.confirmationStep.madeUnavailableDataSets':
    'Data sets made unavailable:',
  'organizations.datasetsDialog.confirmationStep.noChange': 'No Change',
  'organizations.datasetsDialog.confirmationStep.successText':
    'Available data sets were updated successfully.',
  'organizations.createEditDialog.organizationNameInvalidCharactersError':
    "Organization name must only contain letters, numbers, '_' and '-'",
  'organizations.createEditDialog.organizationNameStartEndCharactersError':
    'Organization name must start and end with a letter or number',
};
